module.exports = __webpack_public_path__ + "img/pdf.97f1447a.svg";